
import { Component, Mixins, Ref } from "vue-property-decorator";
import Select from "./Select.vue";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import CompanySelectorModal from "../../components/widgets/Modals/CompanySelectorModal.vue";

@Component({
  components: {
    Select,
    CompanySelectorModal
  }
})
export default class OrderBySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Ref() readonly orderBySelectorModal!: CompanySelectorModal;

  lookup() {
    this.orderBySelectorModal.show();
  }

  companySelected(company) {
    if (company && company.displayId) {
      if (this.multiple) this.localValue.push(company.displayId);
      else this.localValue = company.displayId;
    }
  }
}
